document.addEventListener("click", function (event) {
    // 1. Detectamos si el clic fue en un botón dentro de .multiEtiqueta
    const boton = event.target.closest(".multiEtiqueta button");
    
    // Si no es un botón de etiqueta, salimos
    if (!boton) return;

    // 2. Obtenemos los identificadores
    const id = boton.getAttribute("data-etiqueda");   // ej: "cabecera"
    const modalId = boton.getAttribute("data-modal"); // ej: "modalProduccionInyeccion"
    
    if (!id || !modalId) return;

    // 3. Localizamos el modal y el contenedor de etiquetas
    const modal = document.getElementById(modalId);
    const contEtiquetas = boton.closest(".multiEtiqueta");
    if (!modal || !contEtiquetas) return;

    // --- LÓGICA DE INTERFAZ ---

    // 1) Quitar clase 'etiquetaSelect' de los hermanos en ese grupo
    const botonesDelGrupo = contEtiquetas.querySelectorAll("button");
    botonesDelGrupo.forEach(btn => btn.classList.remove("etiquetaSelect"));

    // 2) Marcar el botón clickeado
    boton.classList.add("etiquetaSelect");

    // 3) Manejo de las secciones (Canvas) dentro del modal
    const contCanvas = modal.querySelector(".canvaMultiEtiqueta");
    if (!contCanvas) return;

    // Ocultar todos los hijos directos del contenedor de secciones
    Array.from(contCanvas.children).forEach(hijo => {
        hijo.classList.add("oculto");
    });

    // 4) Mostrar la sección correspondiente
    // Construimos el ID: "canva" + "Cabecera"
    const idCanva = "canva" + id.charAt(0).toUpperCase() + id.slice(1);
    const seccionActiva = modal.querySelector("#" + idCanva);

    if (seccionActiva) {
        seccionActiva.classList.remove("oculto");
    }
});